import React, {useEffect, useRef, useState} from 'react';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import PleaseWait from '../../PleaseWait';
import Screen from '../../Screen';
import {readFile} from './readFile';
import {loadSrc} from './loadSrc';
import {TransformWrapper, TransformComponent} from 'react-zoom-pan-pinch';

function EventImageAttachment(props) {
    const {event, file, src, icons, onReturnClick, returnURL = '..'} = props,
        [loaded, setLoaded] = useState(false),
        [[width, height], setSize] = useState([0, 0]),
        [realSrc, setSrc] = useState(null),
        sizeRef = useRef();

    // Load file
    useEffect(() => {
        let waiting = true;

        async function load() {
            if (file) {
                let data = await readFile(file);
                setSrc(data);
            } else {
                let data = await loadSrc(src);
                setSrc(data.src);
            }
            setLoaded(true);
        }
        load();

        return () => (waiting = false);
    }, [file, src]);

    // Get size
    useEffect(() => {
        const {width, height} = sizeRef.current?.getBoundingClientRect() ?? {width: 0, height: 0};
        setSize(currentSize => (currentSize[0] !== width || currentSize[1] !== height ? [width, height] : currentSize));
    });

    if (!loaded) return <PleaseWait />;

    const header = (
        <>
            <TopBarEvent event={event} onReturnClick={onReturnClick} returnURL={returnURL} icons={icons} />
            <hr />
        </>
    );

    return (
        <Screen header={header}>
            <div className="fill-container" ref={sizeRef}>
                <TransformWrapper>
                    <TransformComponent>
                        <div
                            style={{
                                width,
                                height,
                                backgroundImage: 'url("' + realSrc + '")',
                                backgroundPosition: 'center',
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                            }}
                        />
                    </TransformComponent>
                </TransformWrapper>
            </div>
        </Screen>
    );
}

export default EventImageAttachment;
